import useHandleCallEndedEvents from './streamWS_hooks/useHandleCallEndedEvents';
import useHandleCollaboratorCallEnded from './streamWS_hooks/useHandleCollaboratorCallEnded';
import useHandleCollaboratorMessage from './streamWS_hooks/useHandleCollaboratorMessage';
import useHandleConversationMessage from './streamWS_hooks/useHandleConversationMessage';
import useHandleLiveVideoEvents from './streamWS_hooks/useHandleLiveVideoEvents';
import useHandleMessageCategory from './streamWS_hooks/useHandleMessageCategory';
import useHandleTranscriptionSummaries from './streamWS_hooks/useHandleTranscriptionSummaries';

/**
 * Empty component that contains hooks usage for Hermes callbacks
 */
const StreamWSCallbacks = () => {
  useHandleMessageCategory();
  useHandleTranscriptionSummaries();
  useHandleCallEndedEvents();
  useHandleCollaboratorCallEnded();
  useHandleLiveVideoEvents();
  useHandleConversationMessage();
  useHandleCollaboratorMessage();

  return <></>;
};

export default StreamWSCallbacks;
